.menu {
  position: relative;
}

.panel {
  position: absolute;
  z-index: 2;
  top: calc(100% + var(--space-2xs));
  right: 0;

  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  width: 18rem;
  padding: var(--space-s);

  background-color: var(--surface-raised);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-raised);
}

.heading {
  font-size: var(--size-200);
  font-weight: var(--weight-strong);

  color: var(--text);
}

.bulk {
  display: flex;
  gap: var(--space-s);
}

.bulkAction {
  padding: 0;

  font-size: var(--size-100);

  color: var(--accent);

  background: none;
  border: none;

  cursor: pointer;
}

.bulkAction:hover {
  color: var(--accent-strong);

  text-decoration: underline;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);

  max-height: 18rem;
  overflow-y: auto;
}

.group {
  padding-top: var(--space-2xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;

  color: var(--text-faint);
}

.option {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);

  padding: var(--space-3xs) 0;

  font-size: var(--size-200);

  color: var(--text);

  cursor: pointer;
}

.empty {
  font-size: var(--size-200);

  color: var(--text-muted);
}
